import React, { Component } from 'react'
import config from '../../config';
import OutsideNotifier from '../../OutsideNotifier';

export default class ClubSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openDDL: false,
            selectedClub: null
        }
    }

    onSelectClub(club) {
        this.setState({ selectedClub: club, openDDL: false })
    }

    closeDDL() {
        this.setState({ openDDL: false })
    }

    toggleDDL() {
        this.setState({ openDDL: !this.state.openDDL })
    }

    clearSelection(e) {
        e.stopPropagation();
        this.setState({ selectedClub: null })
    }

    onSkip() {
        if (this.props.onSkip) {
            this.props.onSkip()
        }
    }

    onSubmit() {
        if (this.props.onSubmit && this.state.selectedClub) {
            this.props.onSubmit(this.state.selectedClub)
        }
    }

    render() {
        let trans = this.props.trans
        let clubs = this.props.clubs
        if (!clubs || (clubs && clubs.length <= 0)) {
            return null;
        }
        return (
            <div className="si-leagues-card si-sc">
                <div className="si-league-body">
                    <div className="si-sc__wrap">
                        <div className="si-sc__head">
                            <div className="si-sc__title">{trans['joinPublicClubLeague'] || "Join a public club league"}</div>
                            <div className="si-sc__skip" onClick={() => { this.onSkip() }}>{trans['skip'] || "skip"}</div>
                        </div>
                        <ul className="si-sc__list">
                            {
                                clubs.map((club, idx) => {
                                    return (
                                        <li key={idx}>
                                            <img src={config.UEFAImgBase+"teams/logos/140x140/"+ club.Id + ".png"} />
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        <div className="si-sc__desc">{trans['competeAgainstFellowFans'] || "Compete against fellow fans from a UEFA Champions League club"}</div>
                        <OutsideNotifier handler={() => { this.closeDDL() }}>
                            <div className="si-selectBoxes ">
                                <div className="si-dropdown-btn si-flexBox" onClick={() => { this.toggleDDL() }}>
                                    <span>{(this.state.selectedClub) ? this.state.selectedClub.OffName : (trans['pleaseSelect'] || "Please select")}</span>
                                    {
                                        (this.state.selectedClub)
                                            ?
                                            <span className="si-close" onClick={(e) => { this.clearSelection(e) }}>
                                                <i className="icon-ucl-close"></i>
                                            </span>
                                            :
                                            null
                                    }

                                    <i className="icon-ucl-position"></i>
                                </div>
                                <ul className={"si-dropdown-options si-up " + (this.state.openDDL ? "" : "si-hidden")}>
                                    {
                                        clubs.map((club, idx) => {
                                            return (
                                                <li key={idx} onClick={() => { this.onSelectClub(club) }}>
                                                    {club.OffName}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            <br />
                            <div className="si-btn-wrp" >
                                <div className={"si-btn si-btn-secondary-white " + (this.state.selectedClub ? "" : "si-btn-disabled")} onClick={() => { this.onSubmit() }}>
                                    <span>
                                        {trans['done']}
                                    </span>
                                </div>
                            </div>
                        </OutsideNotifier>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/leagues/ClubSelector.js